(function () {
  'use strict';
  if (window.__MAYTRIX_MOBILE_BUILDER__) return;
  var root = document.documentElement;
  var mobile = window.matchMedia('(max-width: 767px)');
  var steps = ['center', 'frame', 'sides', 'delivery'];
  var labels = ['Center', 'Frame', 'Sides', 'Delivery'];
  var active = 'center';
  var positions = {};
  var chevron = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" fill="none"><path d="m12 5-5 5 5 5" style="fill:none!important;stroke:currentColor" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var frame = 0;
  var panels = [];
  var builderObserver;
  var observedBuilder;
  var choices = {center: {open: false}, pattern: {open: false}};
  var centerSwitch = null;
  var sidesSwitch = null;
  var sideStyleSelector = '[data-category-id="-5rVa2YKJ10MFUHYFmKoRBJi"]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function sideSelection(block) {
    var selected = block.querySelector(sideStyleSelector + ' .cpb-option[aria-pressed="true"]');
    return selected && selected.dataset.optionId;
  }

  function finishSidesSwitch() {
    var state = sidesSwitch;
    if (!state) return;
    sidesSwitch = null;
    clearTimeout(state.timer);
    if (state.animation) state.animation.cancel();
    ['height', 'overflow', 'overflow-anchor'].forEach(function (name) { state.block.style.removeProperty(name); });
    state.inert.forEach(function (value, element) { element.inert = value; });
    state.block.removeAttribute('aria-busy');
    state.block.removeAttribute('data-myx-sides-switch');
  }

  function beginSidesSwitch() {
    if (!enabled() || active !== 'sides') return;
    var block = document.querySelector('[data-myx-focus-section="sides"] .cpb-panel-categories-container');
    if (!block) return;
    finishSidesSwitch();
    var state = sidesSwitch = {block:block, height:block.getBoundingClientRect().height, selected:sideSelection(block), inert:new Map(), timer:0};
    block.style.height = state.height + 'px';
    block.style.overflow = 'hidden';
    block.style.overflowAnchor = 'none';
    block.setAttribute('aria-busy', 'true');
    block.dataset.myxSidesSwitch = 'out';
    updateSidesSwitch();
    state.timer = setTimeout(finishSidesSwitch, 4500);
  }

  function updateSidesSwitch() {
    var state = sidesSwitch;
    if (!state || state.block.dataset.myxSidesSwitch !== 'out') return;
    Array.from(state.block.children).forEach(function (element) {
      if (element.matches(sideStyleSelector)) return;
      if (!state.inert.has(element)) state.inert.set(element, element.inert);
      element.inert = true;
    });
    if (sideSelection(state.block) === state.selected) return;
    // Ongoing RGB/CPB updates must not keep postponing the controls' reveal.
    if (state.settling) return;
    state.settling = true;
    clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      if (sidesSwitch !== state || !state.block.isConnected) { finishSidesSwitch(); return; }
      var block = state.block;
      block.style.height = 'auto';
      var height = block.getBoundingClientRect().height;
      block.style.height = height + 'px';
      block.dataset.myxSidesSwitch = 'in';
      if (!reduceMotion.matches) state.animation = block.animate(
        [{height:state.height+'px'}, {height:height+'px'}],
        {duration:280, easing:'cubic-bezier(.22,1,.36,1)'}
      );
      state.timer = setTimeout(function () { if (sidesSwitch === state) finishSidesSwitch(); }, 320);
    }, 100);
  }

  function finishCenterSwitch() {
    var state = centerSwitch;
    if (!state) return;
    centerSwitch = null;
    clearTimeout(state.timer);
    state.animations.forEach(function (animation) { animation.cancel(); });
    ['height', 'overflow', 'opacity', 'overflow-anchor'].forEach(function (name) { state.block.style.removeProperty(name); });
    state.block.removeAttribute('aria-busy');
    state.block.removeAttribute('data-myx-center-switch');
  }

  function beginCenterSwitch() {
    if (!enabled() || active !== 'center') return;
    var block = document.querySelector('#product-builder .myx-start-categories');
    if (!block) return;
    finishCenterSwitch();
    var state = centerSwitch = {block:block, height:block.getBoundingClientRect().height, animations:[], timer:0};
    block.style.height = state.height + 'px';
    block.style.overflow = 'hidden';
    block.style.overflowAnchor = 'none';
    block.setAttribute('aria-busy', 'true');
    block.dataset.myxCenterSwitch = 'out';
    block.style.opacity = '0';
    state.animations.push(block.animate([{opacity:1},{opacity:0}], {duration:reduceMotion.matches ? 70 : 140, easing:'ease-out'}));
    state.timer = setTimeout(finishCenterSwitch, 1800);
  }

  function settleCenterSwitch() {
    var state = centerSwitch;
    if (!state) return;
    clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      if (centerSwitch !== state || !state.block.isConnected) { finishCenterSwitch(); return; }
      var block = state.block;
      state.animations.forEach(function (animation) { animation.cancel(); });
      block.style.height = 'auto';
      var height = block.getBoundingClientRect().height;
      block.style.height = height + 'px';
      block.style.opacity = '1';
      block.dataset.myxCenterSwitch = 'in';
      state.animations = [block.animate(
        reduceMotion.matches ? [{opacity:0},{opacity:1}] : [{height:state.height+'px', opacity:0}, {height:height+'px', opacity:1}],
        {duration:reduceMotion.matches ? 140 : 280, easing:'cubic-bezier(.22,1,.36,1)'}
      )];
      state.animations[0].finished.then(function () { if (centerSwitch === state) finishCenterSwitch(); }, function () {});
    }, 100);
  }

  function toggleChoice(key, category, content, button) {
    var state = choices[key], wasOpen = state.open;
    var before = content.getBoundingClientRect().height;
    if (state.animation) { state.animation.cancel(); state.animation = null; }
    state.open = !wasOpen;
    if (key !== 'center' || reduceMotion.matches || !content.animate) { queue(); return; }
    category.dataset.myxChoiceCollapsed = 'false';
    button.setAttribute('aria-expanded', String(state.open));
    content.inert = !state.open;
    content.style.overflow = 'hidden';
    var height = content.getBoundingClientRect().height;
    var animation = state.animation = content.animate(
      [{height:before+'px', opacity:wasOpen?1:0}, {height:(state.open?height:0)+'px', opacity:state.open?1:0}],
      {duration:220, easing:'cubic-bezier(.22,1,.36,1)', fill:'forwards'}
    );
    animation.finished.then(function () {
      if (state.animation !== animation) return;
      category.dataset.myxChoiceCollapsed = String(!state.open);
      animation.cancel(); state.animation = null; content.style.removeProperty('overflow'); queue();
    }, function () {});
  }

  function reviewOpen() {
    var q = new URLSearchParams(location.search);
    return document.body.matches('.myx-review-open,.myx-review-pending') ||
      q.get('review') === '1' || q.get('view') === 'maytrix-review';
  }

  function enabled() {
    return !reviewOpen() && panels.length === 4;
  }

  function pinDesktopActions() {
    if (!enabled() || mobile.matches || !document.body.classList.contains('myx-desktop-customizer')) return;
    var column = document.querySelector('#product-builder .cpb-panels-container');
    if (!column) return;
    var anchor = column.querySelector('.myx-desktop-step-tabs') || column;
    var rect = anchor.getBoundingClientRect();
    function variable(name, value) { if (root.style.getPropertyValue(name) !== value) root.style.setProperty(name, value); }
    variable('--myx-desktop-actions-left', rect.left + 'px');
    variable('--myx-desktop-actions-width', Math.max(0, rect.width) + 'px');
    var bar = column.querySelector('.myx-customizer-actions-shell');
    variable('--myx-desktop-actions-height', (bar ? Math.ceil(bar.getBoundingClientRect().height) : 96) + 'px');
  }

  function paint() {
    var on = enabled();
    if (reviewOpen()) { finishCenterSwitch(); finishSidesSwitch(); }
    document.body.classList.toggle('myx-builder-focus', !reviewOpen() && panels.length === 4);
    document.body.classList.toggle('myx-mobile-focus', on && mobile.matches);
    document.body.classList.toggle('myx-desktop-focus', on && !mobile.matches);
    root.classList.toggle('myx-mobile-builder-route', !reviewOpen());
    root.dataset.myxMobileStep = active;
    panels.forEach(function (panel, index) {
      var heading = panel.querySelector('.cpb-panel-title');
      if (heading) {
        var centerStyle = choices.center.selected || 'Upload Logo';
        var centerTitle = centerStyle === 'Text' ? 'Enter Text' : centerStyle === 'Upload Logo' ? 'Upload Your Logo or Design' : '';
        var title = [centerTitle === 'Enter Text' ? 'Enter Text' : centerTitle ? 'Upload your logo or design' : '', 'Frame & size', 'Side lighting', 'Delivery'][index];
        var hideTitle = index === 0 && !centerTitle;
        if (heading.hasAttribute('data-myx-center-title-hidden') !== hideTitle) heading.toggleAttribute('data-myx-center-title-hidden', hideTitle);
        var progress = 'Step ' + (index + 1) + ' of 4';
        if (heading.dataset.myxMobileProgress !== progress) heading.dataset.myxMobileProgress = progress;
        if (heading.dataset.myxMobileTitle !== title) heading.dataset.myxMobileTitle = title;
        var desktopTitle = [centerTitle, 'Frame & Size', 'Lighting Style', 'Delivery'][index];
        if (heading.dataset.myxDesktopTitle !== desktopTitle) heading.dataset.myxDesktopTitle = desktopTitle;
        var headingLabel = on && mobile.matches ? progress + (title ? '. ' + title : '') : desktopTitle;
        if (headingLabel && heading.getAttribute('aria-label') !== headingLabel) heading.setAttribute('aria-label', headingLabel);
        if (!headingLabel && heading.hasAttribute('aria-label')) heading.removeAttribute('aria-label');
      }
      var hide = on && panel.dataset.myxFocusSection !== active;
      if (panel.hasAttribute('data-myx-focus-hidden') !== hide) panel.toggleAttribute('data-myx-focus-hidden', hide);
      if (panel.inert !== hide) panel.inert = hide;
      var desktopPanel = on && !mobile.matches;
      if (desktopPanel && panel.getAttribute('role') !== 'tabpanel') panel.setAttribute('role', 'tabpanel');
      if (desktopPanel && panel.getAttribute('aria-labelledby') !== 'myx-desktop-tab-' + panel.dataset.myxFocusSection) panel.setAttribute('aria-labelledby', 'myx-desktop-tab-' + panel.dataset.myxFocusSection);
      if (!desktopPanel && panel.getAttribute('role') === 'tabpanel') { panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); }
    });
    if (on) document.querySelectorAll('.myx-customizer-quicknav [data-myx-customizer-step],.myx-desktop-step-tabs [data-myx-customizer-step]').forEach(function (tab) {
      var selected = tab.dataset.myxCustomizerStep === active;
      tab.classList.toggle('is-active', selected);
      if (selected && tab.getAttribute('aria-current') !== 'step') tab.setAttribute('aria-current', 'step');
      if (!selected && tab.hasAttribute('aria-current')) tab.removeAttribute('aria-current');
      if (tab.getAttribute('role') === 'tab') {
        if (tab.getAttribute('aria-selected') !== String(selected)) tab.setAttribute('aria-selected', String(selected));
        if (tab.tabIndex !== (selected ? 0 : -1)) tab.tabIndex = selected ? 0 : -1;
      }
    });
    pinDesktopActions();
  }

  function select(key, fromSectionButton, keepTabFocus) {
    if (!enabled() || steps.indexOf(key) < 0) return false;
    if (key !== active) { finishCenterSwitch(); finishSidesSwitch(); }
    var scroller = document.querySelector('#product-builder .cpb-panels-container');
    var desktopScroll = !mobile.matches && scroller && getComputedStyle(scroller).overflowY === 'auto';
    var positionPrefix = mobile.matches ? 'mobile:' : 'desktop:';
    positions[positionPrefix + active] = desktopScroll ? scroller.scrollTop : window.scrollY;
    active = key;
    paint();
    var target = panels[steps.indexOf(key)].querySelector('h1,h2,h3,[role="heading"]');
    requestAnimationFrame(function () {
      var top = fromSectionButton ? 0 : positions[positionPrefix + key] || 0;
      (desktopScroll ? scroller : window).scrollTo({top: top, behavior: 'auto'});
      if (keepTabFocus) document.getElementById('myx-desktop-tab-' + key)?.focus({preventScroll: true});
      else if (target) {
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
      }
      document.dispatchEvent(new CustomEvent('maytrix:mobile-section-change', {detail: {section: key}}));
    });
    return true;
  }

  function enhanceChoices(builder) {
    function enhance(key, category, content, selected, title) {
      if (!category || !content || !selected) return;
      var state = choices[key];
      var label = selected.getAttribute('data-myx-choice-label') || selected.querySelector('.myx-pattern-label').textContent.trim();
      var changed = state.selected && state.selected !== label;
      if (changed) {
        state.open = false;
        if (state.animation) { state.animation.cancel(); state.animation = null; content.style.removeProperty('overflow'); }
      }
      state.selected = label;
      if (category.dataset.myxCompactChoice !== key) category.dataset.myxCompactChoice = key;
      if (!content.id) content.id = 'myx-' + key + '-choices';
      var button = category.querySelector('.myx-choice-toggle');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'myx-choice-toggle';
        button.innerHTML = '<span><strong></strong><small></small></span>';
        button.querySelector('strong').textContent = title;
        button.addEventListener('click', function () {
          var current = category.querySelector(key === 'center' ? '.cpb-category-content' : '.myx-pattern-grid');
          if (current) toggleChoice(key, category, current, button);
        });
        category.insertBefore(button, category.firstChild);
      }
      var summary = button.querySelector('small');
      var displayTitle = title;
      if (key === 'center' && category.dataset.myxUploadSelected !== String(label === 'Upload Logo')) category.dataset.myxUploadSelected = String(label === 'Upload Logo');
      if (button.querySelector('strong').textContent !== displayTitle) button.querySelector('strong').textContent = displayTitle;
      if (summary.textContent !== label) summary.textContent = label;
      if (button.getAttribute('aria-controls') !== content.id) button.setAttribute('aria-controls', content.id);
      if (button.getAttribute('aria-expanded') !== String(state.open)) button.setAttribute('aria-expanded', String(state.open));
      if (!state.animation && category.dataset.myxChoiceCollapsed !== String(!state.open)) category.dataset.myxChoiceCollapsed = String(!state.open);
      // Return keyboard focus to the selector before hiding the chosen card.
      if (changed && content.contains(document.activeElement)) button.focus({preventScroll: true});
      if (content.inert !== !state.open) content.inert = !state.open;
      if (changed && key === 'center') settleCenterSwitch();
    }
    var center = builder.querySelector('[data-category-id="rGBsXKwwThNiSwykhXb9lpED"]');
    if (center) {
      // Keep the mounted CPB controls and their keyboard order in the same flow.
      var categories = center.parentElement;
      var primary = categories.querySelector(':scope > .myx-primary-input');
      if (primary && categories.firstElementChild !== primary) categories.insertBefore(primary, categories.firstElementChild);
      var starColor = categories.querySelector(':scope > [data-myx-extension-category="star-color"]');
      var mainCategories = Array.from(categories.children).filter(function (category) { return category !== center && category !== starColor; });
      var lastMain = mainCategories[mainCategories.length - 1];
      if (lastMain && center.previousElementSibling !== lastMain) categories.appendChild(center);
      // Starlight's dependent palette stays beside its selector when enabled.
      if (starColor && center.nextElementSibling !== starColor) center.insertAdjacentElement('afterend', starColor);
    }
    var star = center && center.dataset.myxStarryActive === 'true';
    enhance('center', center, center && center.querySelector('.cpb-category-content'),
      center && center.querySelector(star ? '[data-myx-choice-label="Starlight"]' : '[data-myx-choice-group="center"][aria-pressed="true"]'), 'Other Center Styles');
    var pattern = builder.querySelector('[data-myx-extension-category="bar-pattern"]');
    enhance('pattern', pattern, pattern && pattern.querySelector('.myx-pattern-grid'),
      pattern && pattern.querySelector('[data-myx-bar-pattern][aria-checked="true"]'), 'Choose Your Light Pattern');
  }

  function refineSectionLabels(builder) {
    var labels = {
      'ewsqpkHYBWFEbxeuQx2MyANc': 'Logo Outline',
      'PBO5FoiL7WyPoltf_adurqLd': 'Logo Lighting',
      'isXiGLkqYyvCvXqsv4l0QLOX': 'Font',
      'kU4ohHIkyE-mXjYFoFLSscwb': 'Text Size',
      'JTXoUcEXaLD_BdJU2yNZQFyU': 'Text Color',
      '9Qos5yoFhBABVdL2vB4VBl0o': 'Shape',
      'HLDWufZPnynTp9Z5O_n85-_k': 'Finish',
      'Kd1c_WSV_iUzEHP8raqt8zXx': 'Corner Style',
      'LB4oi7z56Ta0OZehKxWNh6o0': 'Size',
      'CQ5DSHGSBYKcjbeq1b8rf7MU': 'POPULAR SIZES',
      'Zs0mISKbbkrsanNymAIa6Zqf': 'POPULAR SIZES',
      'SAvhX7xAkC66xUbZf1toKKOW': 'Units',
      'aE4hNil-ULOoL_nuXhFekRZl': 'Custom Size',
      'dbIF9OR5ZazT43lgZsJxGlfh': 'Custom Size',
      'UrSKZIETH8x08xhpeuDYPDaQ': 'Light Color',
      '4qoRqj0Fds_iRKAoRemupDzi': 'Side Text',
      'DkvYo6CNoHB87aIPnRYEvu8v': 'Font',
      'QIKsaieim4U8XmKkOQ26QBAt': 'Text Color',
      'gMkDYozZJBDN8GYrPVJS--NR': 'LED Bar Color',
      'fD2kHs7C9MhutByPyc8Fup71': 'LED Bar Color',
      'BGKHZ-5NH8Q20vxd1xZh8vGR': 'Delivery Window',
      'm6Hu4SPi5Ld_sT6Vn2Ob8K9p': 'Payment Option'
    };
    Object.keys(labels).forEach(function (id) {
      var category = builder.querySelector('[data-category-id="' + id + '"]');
      var heading = category && category.querySelector('.cpb-category-title');
      var label = heading && heading.querySelector('.cpb-category-title__inner > span');
      if (!label) return;
      if (label.dataset.myxShortLabel !== labels[id]) label.dataset.myxShortLabel = labels[id];
      if (label.getAttribute('aria-label') !== labels[id]) label.setAttribute('aria-label', labels[id]);
      if (label.getAttribute('role') !== 'heading') { label.setAttribute('role', 'heading'); label.setAttribute('aria-level', '3'); }
      var style = getComputedStyle(label.parentElement);
      if (label.style.getPropertyValue('--myx-short-label-size') !== style.fontSize) label.style.setProperty('--myx-short-label-size', style.fontSize);
      if (label.style.getPropertyValue('--myx-short-label-height') !== style.lineHeight) label.style.setProperty('--myx-short-label-height', style.lineHeight);
    });
    function controlLabel(node, text, id) {
      if (!node) return;
      if (!node.hasAttribute('data-myx-control-label')) {
        var style = getComputedStyle(node);
        node.style.setProperty('--myx-control-label-size', style.fontSize);
        node.style.setProperty('--myx-control-label-height', style.lineHeight);
      }
      if (node.dataset.myxControlLabel !== text) node.dataset.myxControlLabel = text;
      if (node.getAttribute('aria-label') !== text) node.setAttribute('aria-label', text);
      if (id && node.id !== id) node.id = id;
    }
    controlLabel(builder.querySelector('label[for="myx-proportional-size"]'), 'Scale');
    [['kF4lvyIKrihWaPIn_2soR_O4', 'Width', 'myx-custom-width-label'], ['m_iFPB8o-mZvEqPZGLqLC2_m', 'Height', 'myx-custom-height-label'], ['JWL9jsM-zQ2w-fP_wEd6nexP', 'Width', 'myx-custom-width-cm-label'], ['xJ4pqSdWr_tLgm3ulA6kYXgp', 'Height', 'myx-custom-height-cm-label']].forEach(function (item) {
      var counter = builder.querySelector('.cpb-category-counter [data-option-id="' + item[0] + '"]');
      if (!counter) return;
      controlLabel(counter.querySelector('.cpb-counter__label'), item[1], item[2]);
      var input = counter.querySelector('input');
      if (input && input.getAttribute('aria-labelledby') !== item[2]) input.setAttribute('aria-labelledby', item[2]);
    });
  }

  function sync() {
    frame = 0;
    var builder = document.getElementById('product-builder');
    if (!builder) return;
    refineSectionLabels(builder);
    builder.querySelectorAll('[data-myx-start-heading]').forEach(function (heading) {
      if (/upload your logo or design/i.test(heading.dataset.myxStartHeading)) heading.dataset.myxStartHeading = 'Step 1 - Upload your logo';
      if (/upload your logo/i.test(heading.dataset.myxStartHeading)) heading.setAttribute('aria-label', 'Step 1 - Upload your logo');
    });
    var found = Array.from(builder.querySelectorAll('h1,h2,h3,[role="heading"]'));
    panels = steps.map(function (key, index) {
      var heading = found.find(function (h) { return new RegExp('STEP\\s*' + (index + 1) + '\\b', 'i').test(h.textContent); });
      return heading && heading.closest('.cpb-panel-wrapper');
    }).filter(Boolean);
    if (panels.length === 4) panels.forEach(function (panel, index) {
      if (!panel.id) panel.id = 'myx-builder-panel-' + steps[index];
      if (panel.dataset.myxFocusSection !== steps[index]) panel.dataset.myxFocusSection = steps[index];
      if (panel.querySelector('.myx-mobile-section-nav')) return;
      var navigation = document.createElement('nav');
      navigation.className = 'myx-mobile-section-nav';
      navigation.setAttribute('aria-label', labels[index] + ' section navigation');
      function addButton(key, direction) {
        var button = document.createElement('button');
        var isNext = direction === 'next';
        button.type = 'button';
        button.className = 'myx-mobile-step-button is-' + direction;
        button.dataset.myxNavigateSection = key;
        button.setAttribute('aria-label', (isNext ? 'Next: ' : 'Back: ') + labels[steps.indexOf(key)]);
        button.innerHTML = isNext ? '<span>Next</span>' + chevron : chevron + '<span>Back</span>';
        navigation.appendChild(button);
      }
      if (index > 0) addButton(steps[index - 1], 'back');
      if (index < steps.length - 1) addButton(steps[index + 1], 'next');
      panel.appendChild(navigation);
    });
    var options = builder.querySelector('.cpb-panels-container');
    if (panels.length === 4 && options) {
      var tabs = options.querySelector('.myx-desktop-step-tabs');
      if (!tabs) {
        tabs = document.createElement('div');
        tabs.className = 'myx-desktop-step-tabs';
        tabs.setAttribute('role', 'tablist');
        tabs.setAttribute('aria-label', 'Design sections');
        var rail = document.createElement('div');
        rail.className = 'myx-desktop-step-tabs__rail';
        tabs.appendChild(rail);
        steps.forEach(function (key, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.id = 'myx-desktop-tab-' + key;
          button.dataset.myxCustomizerStep = key;
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', panels[index].id);
          var label = document.createElement('span');
          label.textContent = labels[index];
          button.appendChild(label);
          rail.appendChild(button);
        });
        options.insertBefore(tabs, options.firstChild);
      }
    }
    builder.querySelectorAll('.myx-desktop-step-tabs [data-myx-customizer-step]').forEach(function (button) {
      if (button.querySelector('svg')) return;
      var mobileTab = document.querySelector('.myx-customizer-quicknav [data-myx-customizer-step="' + button.dataset.myxCustomizerStep + '"]');
      var icon = mobileTab && mobileTab.querySelector('svg');
      if (icon) button.insertBefore(icon.cloneNode(true), button.firstChild);
    });
    var preview = builder.querySelector('.cpb-preview-container');
    if (preview && !preview.querySelector('.myx-mobile-back')) {
      var back = document.createElement('a');
      back.className = 'myx-mobile-back';
      back.href = '/';
      back.innerHTML = chevron + '<span>Back</span>';
      back.setAttribute('aria-label', 'Back to Maytrix');
      preview.appendChild(back);
    }
    if (observedBuilder !== builder) {
      if (builderObserver) builderObserver.disconnect();
      builderObserver = new MutationObserver(function (records) {
        if (records.some(function (record) {
          return record.type === 'childList' ||
            (record.target.matches('[data-myx-choice-group="center"],[data-myx-bar-pattern],[data-myx-starry-active],' + sideStyleSelector + ' .cpb-option') &&
             record.oldValue !== record.target.getAttribute(record.attributeName));
        })) queue();
      });
      builderObserver.observe(builder, {childList: true, subtree: true, attributes: true, attributeOldValue: true,
        attributeFilter: ['aria-pressed', 'aria-checked', 'data-myx-starry-active']});
      observedBuilder = builder;
    }
    enhanceChoices(builder);
    updateSidesSwitch();
    paint();
  }

  function queue() { if (!frame) frame = requestAnimationFrame(sync); }
  document.addEventListener('click', function (event) {
    if (!enabled() || !event.target.closest) return;
    var sectionButton = event.target.closest('[data-myx-navigate-section]');
    var tab = event.target.closest('.myx-customizer-quicknav [data-myx-customizer-step],.myx-desktop-step-tabs [data-myx-customizer-step]');
    if (!sectionButton && !tab) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    select(sectionButton ? sectionButton.dataset.myxNavigateSection : tab.dataset.myxCustomizerStep, !!sectionButton, !!tab?.closest('.myx-desktop-step-tabs'));
  }, true);
  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest?.('.myx-desktop-step-tabs [role="tab"]');
    if (!enabled() || !tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    var index = steps.indexOf(tab.dataset.myxCustomizerStep);
    var next = event.key === 'Home' ? 0 : event.key === 'End' ? 3 : (index + (event.key === 'ArrowRight' ? 1 : 3)) % 4;
    event.preventDefault();
    select(steps[next], false, true);
  });
  function keyboard() {
    var v = window.visualViewport;
    var editing = document.activeElement && document.activeElement.matches('input:not([type=radio]):not([type=checkbox]),textarea,[contenteditable=true]');
    document.body.classList.toggle('myx-mobile-keyboard', !!(enabled() && mobile.matches && v && editing && v.height < window.innerHeight * .76));
  }
  function boot() {
    document.addEventListener('maytrix:center-choice-transition', beginCenterSwitch);
    document.addEventListener('maytrix:sides-choice-transition', beginSidesSwitch);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { finishCenterSwitch(); finishSidesSwitch(); } });
    window.addEventListener('pagehide', function () { finishCenterSwitch(); finishSidesSwitch(); });
    new MutationObserver(queue).observe(document.body, {attributes: true, attributeFilter: ['class']});
    var mount = new MutationObserver(queue);
    mount.observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true});
    ['CPB_ON_PRODUCT_MOUNTED', 'CPB_ON_OPTIONS_UPDATE'].forEach(function (name) { document.addEventListener(name, queue); document.body.addEventListener(name, queue); });
    window.addEventListener('popstate', queue);
    window.addEventListener('pageshow', queue);
    window.addEventListener('resize', queue);
    mobile.addEventListener('change', queue);
    document.addEventListener('focusin', keyboard);
    document.addEventListener('focusout', keyboard);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', keyboard);
    queue();
  }
  window.__MAYTRIX_MOBILE_BUILDER__ = {version: '1.4.1', select: select};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  var uploadMedia = window.matchMedia('(max-width:767px)');
  function uploadCopy() {
    document.querySelectorAll('#product-builder [data-category-id="Qxp4cCZHBPSyjx8HBigw9Z0c"] *').forEach(function (node) {
      if (node.children.length || !/^(?:Click|Tap) to upload$/.test(node.textContent.trim())) return;
      var text=uploadMedia.matches?'Tap to upload':'Click to upload';
      if(node.textContent.trim()!==text)node.textContent=text;
    });
  }
  new MutationObserver(uploadCopy).observe(document.getElementById('product-builder')||document.body,{subtree:true,childList:true});
  uploadMedia.addEventListener('change',uploadCopy); uploadCopy();
})();

/* Presentation only: preserve CPB option IDs, dimensions and pricing. */
(function () {
  'use strict';
  var selector = '[data-category-id="Zs0mISKbbkrsanNymAIa6Zqf"], [data-category-id="CQ5DSHGSBYKcjbeq1b8rf7MU"]';
  var scheduled = 0;
  function sync() {
    scheduled = 0;
    var root = document.getElementById('product-builder');
    if (!root) return;
    root.querySelectorAll(selector).forEach(function (category) {
      if (category.getAttribute('data-myx-compact-sizes') !== 'true') category.setAttribute('data-myx-compact-sizes', 'true');
      category.querySelectorAll('.cpb-option[data-option-id]').forEach(function (card) {
        var label = Array.from(card.children).find(function (node) {
          return node.tagName === 'DIV' && !node.classList.contains('cpb-option-description');
        });
        var match = label && label.textContent.trim().match(/^(Classic|Statement|Gallery|Feature|Grand)\s*[—–-]\s*(.+)$/);
        if (!match) return;
        if (label.getAttribute('data-myx-size-name') !== match[1]) label.setAttribute('data-myx-size-name', match[1]);
        if (label.getAttribute('data-myx-size-dimensions') !== match[2]) label.setAttribute('data-myx-size-dimensions', match[2]);
        var accessibleLabel = match[1] + ', ' + match[2];
        if (card.getAttribute('aria-label') !== accessibleLabel) card.setAttribute('aria-label', accessibleLabel);
      });
    });
    var mode = root.querySelector('[data-category-id="LB4oi7z56Ta0OZehKxWNh6o0"] [data-option-id="ChhzZNLNHc6HoBDjegeEYT4G"] > div');
    if (mode && mode.textContent.trim() === 'Signature Sizes') mode.textContent = 'Popular Sizes';
  }
  function queue() { if (!scheduled) scheduled = requestAnimationFrame(sync); }
  function boot() {
    var root = document.getElementById('product-builder');
    if (!root) return;
    new MutationObserver(queue).observe(root, {childList: true, subtree: true, characterData: true});
    queue();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
